import React from 'react';

const Scalebar = ({ info }) => {
  if (!info) return null;

  return (
    <div
      className="absolute left-5 text-center text-xs text-gray-800 dark:text-gray-200 bg-white/50 dark:bg-black/50 px-2 py-1 rounded-sm z-20 pointer-events-none"
      style={{
        bottom: 'calc(1.25rem + env(safe-area-inset-bottom))' // 1.25rem is equivalent to bottom-5
      }}
    >
      <div style={{
        width: `${info.pixelWidth}px`,
        height: '5px',
        backgroundColor: 'currentColor',
        marginBottom: '4px'
      }} />
      <span>{info.label}</span>
    </div>
  );
};

export default Scalebar;